import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';
import { Button, Select } from '@/ui';

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1.5rem;
`;

export const StyledSelect = styled(Select)`
  margin-bottom: 1.5rem;
`;

export const StyledButton = styled(Button)`
  &&& {
    min-height: 2.5rem;
    width: 100%;
    border-color: transparent;
  }
`;
